import { ConfigProvider, message, Modal } from 'antd'
import { useLayoutEffect } from 'react'
import {
  BrowserRouter,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom'
import 'simplebar-react/dist/simplebar.min.css'
import './App.less'
import { Router } from './Router'
import CommonDialogLayout from './components/CommonDialogLayout/CommonDialogLayout'
import { uiController } from './controllers/uiController'
import { PAGE_LINKS } from './helpers/commonConsts'
import { commonUtils } from './helpers/commonUtils'
import { routerService } from './services/routerService/routerService'
import { userService } from './services/userService'

const RouterLayout = () => {
  // 只要使用了 useNavigate ，url 变化都会导致此组件重新渲染
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const params: any = useParams()
  routerService.navigate = useNavigate()
  const location = useLocation()
  routerService.location = location
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setSearchParams] = useSearchParams()
  routerService.setURLSearchParams = setSearchParams
  useLayoutEffect(() => {
    routerService.params = {
      ...params,
      ...commonUtils.getUrlParams(),
    }
  })

  useLayoutEffect(() => {
    if (!commonUtils.isMobile() && location.pathname === PAGE_LINKS.home) {
      window.scrollTo(0, 0)
    }
  }, [location.pathname])

  return null
}

export default function App() {
  const [messageApi, contextHolder] = message.useMessage()
  const [modalApi, modalContextHolder] = Modal.useModal()
  uiController.message = messageApi
  uiController.modal = modalApi
  return (
    <ConfigProvider
      theme={{
        token: {
          colorText: '#212B36',
          colorPrimary: '#1fcdb6',
          colorInfo: '#1fcdb6',
        },
        components: {
          Dropdown: {
            controlItemBgHover: '#1fcdb61a',
          },
        },
      }}
      button={{
        autoInsertSpace: false,
      }}
    >
      <BrowserRouter>
        <CommonDialogLayout />
        {contextHolder}
        {modalContextHolder}
        <RouterLayout />
        <Router />
      </BrowserRouter>
    </ConfigProvider>
  )
}

uiController.init()
userService.init()
